export const environment = {
  production: true
  ,urlbase:"https://publicapi.fornituralternativa.com"
  // ,urlbase:"http://localhost:58266"
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts